import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useInView, inView, InView } from 'react-intersection-observer';
import { connect } from "react-redux";
import { motion } from "framer-motion";
import { Link as LinkRouter, useHistory, useNavigate, Redirect } from 'react-router-dom';
import { withRouter } from 'react-router';
import {
  Container,
  Marker,
  Link,
  ProjectTag,
  WorkDate,
  Desc,
  NavDOMLinkAbout,
  WorkListContainer,
  Indicator,
  WorkItem,
  ClearFilters,
  TagsContainer,
  WorkPreview,
  WorkImageContainer,
  FiltersToggle,
  WorkImage,
  Divider,
  FiltersContainer,
  Filter,
  ToTop,
  DetailsContainer,
  MobileLink,
  CaptionText,
  CaptionText1,
  CaptionText2,
  MarkerL,
} from "./WorkElements";


const Works = ({ projects, toggle, mobileToggle, clearFilters, filters, photoFilter, audioFilter, projectFilter, studyFilter, fabricFilter }) => {

  const [projectDisplayed, setProjectDisplayed] = useState(0);
  const [hoverAllowed, setHoverAllowed] = useState(true);
  const [imageZoomed, setImageZoomed] = useState(false);

  const { ref: myRef1, inView, entry } = useInView({
    rootMargin: '-210px'
  });


  const [projectValue, setProjectValue] = useState(0);

  const toggleImgZoom = () => {
    setImageZoomed(!imageZoomed);
    // console.log("Img Toggle reached.");
    // console.log("curr zoom status: " + imageZoomed);
  };

  const isOdd = (index) => {
    if (index % 2 == 0) {
      return true;
    } else {
      return false;
    }
  };

  // ----------------------------------------------------------------------------------------
  // ON SCROLL, UPDATE THE IMAGE AND DESCRIPTION DETAILS
  // const changeSelector = () => {
  //   // if scroll = project number * divided value
  //   if(window.scrollY >= 80 && window.scrollY < 250) {
  //       // setCurrImage(true);
  //     console.log("got to scroll listener event");
  //     setProjectDisplayed(2);
  //   } else {
  //       // setCurrImage(false);
  //     }
  // };

  // useEffect(() => {
  //   window.addEventListener('scroll', changeSelector)
  // }, []);

  const handleDisplayProject = (index) => {
    var currHoverAllowed = hoverAllowed;
    // console.log("proj: " + projectDisplayed);
    // console.log("hover: " + hoverAllowed);

    if (index > 16) {
      setProjectDisplayed(1);
    } else if (index == 0) {
      setProjectDisplayed(15);
    } else if (index != -1) {
      setProjectDisplayed(index);
      setHoverAllowed(false);
      // console.log("index: " + index);
    } else if (projectDisplayed == index) {
      setProjectDisplayed(-1);
      setHoverAllowed(true);
      // console.log("deselecting");
    } else {
      setHoverAllowed(true);
      // setProjectDisplayed(0);
      // console.log("hover: " + hoverAllowed);
      // console.log("deselecting");
    }
  };

  const togglePage = () => {
    handleDisplayProject(-1);
  };

  // ARROWS TO SWITCH BETWEEN PROJECTS, ANIMATE VERTICALLY

  // function ProjTags({ tag, index, tagsLength }) {
  //   // if (index == tagsLength - 1) {
  //   //   return (
  //   //     <ProjectTag>{tag}.</ProjectTag>
  //   //   );
  //   // } else {
  //   //   return <ProjectTag>{tag}. </ProjectTag>;
  //   // }
  //     return <ProjectTag>{tag}.<br /></ProjectTag>;
  // }

  // let project_previews = projects.map((project) => {
  //   if (project.id < 16) {
  //     return (
  //       <WorkImageItem>
  //         <Image>
  //           <img src={"imgs/" + project.imgs[0]} />
  //         </Image>
  //       </WorkImageItem>
  //     )
  //   }
  // });

  
  const p0 = { name: "Austin E. Kim", loc: "North Georgia", semester: "B. 1998", link: "", desc: ["NYC arts and culture programs professional. Experience with curatorial, exhibition, public art, and cultural programming. Experience in galleries, nonprofit, public art, and independent arts settings.", "1/2 of Living Skin."], imgPath: "", imgs: []};

  const p1 = { name: "Korea Art Forum", loc: "Production Manager, Korea Art Forum (KAF)", semester: "2025—Current", link: "https;//kafny.org", desc: ["Coordinated multiple concurrent arts, exhibition, and public programming projects. Managed schedules, deadlines,  communications, documentation, logistics, budgets, reports, and deliverables.", "Administrative and operational support to Director, while coordinating with artists, curators, cultural organizations, community partners, and government agencies such as LIRR, NYCSBS, SUCASA, NYC DOT, NYC Parks, NYC DCLA.", "Onsite operational and audiovisual support, event photography, website and social media management, email newsletters, grant writing, and publicity materials for all KAF arts programs."], imgPath: "kaf/all/", imgs: []};
  console.log("p1 images, path: " + p1.imgPath);
  for (let i = 0; i < 16; i++) {
    let imgName = p1.imgPath + i.toString() + ".jpg";
    p1.imgs.push(imgName);
  }
  console.log(p1.imgs);

  const p2 = { name: "Murray Hill Lights", loc: "Korea Art Forum", semester: "Summer 2026", link: "https://kafny.org/murray-hill-lights", desc: ["2026 Public Realm Commercial District Lighting Grant, New York City Department of Small Business Service.", "Multi-colored light installation that transforms Barton Ave into a safe, vibrant public space. MHL expands art, transforming everyday life into a platform for creativity in Murray Hill, Queens."], imgPath: "kaf/mhl/", imgs: []};
  console.log("p2 images, path: " + p2.imgPath);
  for (let i = 0; i < 7; i++) {
    let imgName = p2.imgPath + i.toString() + ".jpeg";
    p2.imgs.push(imgName);
  }
  console.log(p2.imgs);

  const p3 = { name: "Living Skin", loc: "Living Skin", link: "https://livingskin.site", semester: "2023-Current", desc: ["Curatorial project based in New York, NY founded by Austin Kim and Jerome Wang.", "Since 2023 Living Skin has produced 25+ exhibitions and arts projects in Bushwick, NY, Manhattan’s Chinatown, and Cal-Arts in Escondido."], imgPath: "livingskin/", imgs: []};
  console.log("p3 images, path: " + p3.imgPath);
  for (let i = 0; i < 28; i++) {
    let imgName = p3.imgPath + i.toString() + ".jpg";
    p3.imgs.push(imgName);
  }
  console.log(p3.imgs);
  
  const p4 = { name: "June Homes", semester: "2020-2022", loc: "UX Designer, June Homes", link: "https://junehomes.com", desc: ["Overview of initaitves designed at June Homes as UX Designer. Includes new Design System, iOS App designs, and multiple apartment rental system revisions."], imgPath: "june/", imgs: []};
  console.log("p4 images, path: " + p4.imgPath);
  for (let i = 0; i < 10; i++) {
    let imgName = p4.imgPath + i.toString() + ".jpg";
    p4.imgs.push(imgName);
  }
  console.log(p4.imgs);

  const p5 = { name: "Sunnyside Rhythm Block", semester: "April 2026", loc: "Korea Art Forum", link: "https://kafny.org/sunnyside-rhythm-block", desc: ["Series of public performance arts and culture programming presented by Korea Art Forum, and produced by gong, spotlighting AAPI world sounds through traditional performance, DJs, and community energy on the shared street."], imgPath: "kaf/srb/", imgs: []};
  console.log("p5 images, path: " + p5.imgPath);
  for (let i = 0; i < 14; i++) {
    let imgName = p5.imgPath + i.toString() + ".jpeg";
    p5.imgs.push(imgName);
  }
  console.log(p5.imgs);

  const p6 = { name: "OASIS in Sculpture", semester: "Spring-Summer 2026", loc: "Teaching Artist, Korea Art Forum", link: "https://kafny.org/oasis-in-sculpture", desc: ["Twelve residents of the Self-help Big Six NORC participated in a 12-session sculpture workshop led by teaching artist Austin Kim. The participants explored artistic techniques such as collage, texture, color, folding, cutting, and gluing, while building paper sculptures inspired by nature—such as trees and flowers—as well as unique 3D forms, a tapestry, and large-scale abstract sculptures.", "The showcase features works from twelve members and will take place on Monday, June 4, 2026, from 2:00pm to 4:00pm, in the Community Room at Self-help Big Six NORC, 59-15 47th Avenue, Woodside, NY 11377."], imgPath: "kaf/oasis/", imgs: []};
  console.log("p6 images, path: " + p6.imgPath);
  for (let i = 0; i < 10; i++) {
    let imgName = p6.imgPath + i.toString() + ".jpeg";
    p6.imgs.push(imgName);
  }
  console.log(p6.imgs);

  const p7 = { name: "Sunnyisde Dance Project", semester: "April 2025", loc: "Korea Art Forum", link: "https://kafny.org/2025-sunnyside-dance-project", desc: ["Unique cultural initiative presenting traditional Korean dance forms in partnership with the NYC DOT Open Streets program. SDP features captivating participatory dances and/or drum performances, bringing together vibrant community engagement with Korea's rich artistic traditions.", "All performances took place on 46th Street between Queens Blvd and Greenpoint Avenue in Sunnyside, Queens, on April 27 in celebration of Earth Day and May 4, 11, and 18 for Asian Heritage Month."], imgPath: "kaf/sdp/", imgs: []};
  console.log("p7 images, path: " + p7.imgPath);
  for (let i = 0; i < 11; i++) {
    let imgName = p7.imgPath + i.toString() + ".jpeg";
    p7.imgs.push(imgName);
  }
  console.log(p7.imgs);

  const p8 = { name: "Shared Dialouge, Shared Space (SDSS)", semester: "2025, 2026", loc: "Production, Korea Art Forum", link: "https://kafny.org/2026-sdss-part-1", desc: ["Ongoing series of outdoor participatory art events held at accessible community hubs in immigrant neighborhoods around New York City. SDSS offers residents and visitors the unique opportunity to engage directly with artists and work with them to develop projects that address issues of language, identity, migration, conflict, and cultural production – key issues that define the experience of New Yorkers.", "These works culminate in an indoor exhibition and public art installations across New York City."], imgPath: "kaf/sdss/", imgs: []};
  console.log("p8 images, path: " + p8.imgPath);
  for (let i = 0; i < 19; i++) {
    let imgName = p8.imgPath + i.toString() + ".jpeg";
    p8.imgs.push(imgName);
  }
  console.log(p8.imgs);

  const p9 = { name: "SDSS Catalog", semester: "2025", loc: "Korea Art Forum", link: "https://7838b2ad-eb64-42d5-95a0-fd5dd47cba17.usrfiles.com/ugd/7838b2_2c85144bc3bc4b659cbedec29306c0fc.pdf", desc: ["Catalog design for the 2025 Shared Dialogue, Shared Space program, titled Painting as a Commons. Features 10 public art engagements, 1 indoor exhibition, 4 outdoor temporary public art installations, and 3 essays.", "In English, Korean, Chinese, and Spanish. 258 pages."], imgPath: "kaf/catalog/", imgs: []};
  console.log("p9 images, path: " + p9.imgPath);
  for (let i = 0; i < 12; i++) {
    let imgName = p9.imgPath + i.toString() + ".jpg";
    p9.imgs.push(imgName);
  }
  console.log(p9.imgs);
  
  const p10 = { name: "Art Handling", semester: "2023-Current", loc: "S.V.A., M.O.C.A., nAscent, Hesse Flatow, High Noon Gallery, Peninsula Gallery, Living Skin", link: "", desc: ["Art Handling work: Installation (private, commercial), Packing, Transportation."], imgPath: "handling/", imgs: []};
  console.log("p10 images, path: " + p10.imgPath);
  for (let i = 0; i < 18; i++) {
    let imgName = p10.imgPath + i.toString() + ".jpeg";
    p10.imgs.push(imgName);
  }
  console.log(p10.imgs);

  const p11 = { name: "Nine", semester: "September 2025-July 2026", loc: "Nine", link: "https://ninenyc.org", desc: ["Collective art space in Chinatown / Two Bridges, New York initiated by blue boy, Curmudgeon, Living Skin, and Service. Established through a network of peers sourced by Austin Kim to push the narrative of alternative spaces.", "Nine houses rotating exhibitions, public programs, and community-centered activations. Currently, Nine is shared by Bob’s Gallery, Curmdugeon, Mall, and Site Service."], imgPath: "nine/", imgs: []};
  console.log("p11 images, path: " + p11.imgPath);
  for (let i = 0; i < 9; i++) {
    let imgName = p11.imgPath + i.toString() + ".jpg";
    p11.imgs.push(imgName);
  }
  console.log(p11.imgs);

  const p12 = { name: "Selected Design Work", semester: "2022-Current", loc: "", link: "", desc: ["Selected freelance design projects. Includes work from the 2024 NorthWestern Public Health Review Magazine, Murray Hill LIRR Light Installation Drawings, Korea Art Forum art program banners, and more."], imgPath: "design/", imgs: []};
  console.log("p12 images, path: " + p12.imgPath);
  for (let i = 0; i < 17; i++) {
    let imgName = p12.imgPath + i.toString() + ".jpg";
    p12.imgs.push(imgName);
  }
  console.log(p12.imgs);

  const myProjects = [ p0, p1, p3, p11, p10, p8, p9, p2, p5, p7, p6, p12, p4];

  const ListContainerRef = useRef();

  let observerOptions = {
    root: ListContainerRef.target,
    rootMargin: '2% 0px 97.75% 0px',
    // threshold: 0.1
  }

  const myRefs = [];
  myRefs.push(useRef());

  const historyPage = useHistory();

  const delay = ms => new Promise(
    resolve => setTimeout(resolve, ms)
  );

  const toTopClick = async event => {
    myRefs[0].current?.scrollIntoView({ behavior: 'smooth' });
  };
  
  const handleClick = (index) => {
    // console.log('proj clicked', index);
    // console.log('clicked - current proj index', projectValue);
    // myRefs[index].current?.scrollIntoView({ behavior: 'smooth' });
    // navigate("/" + projectValue + "/works");
    setProjectValue(index);

    // await timeout(1000); //for 1 sec delay
    // setProjectValue(index);
  }
  

  //MAIN PROJECTS LIST
  let projects_list = myProjects.map((project, index) => {

    // let project_tags = project.tags.map((tag, index) => (
    //   <ProjectTag>{tag}</ProjectTag>
    // ));

    // let height_varPreview = "calc(120px + " + ((index) * (90 / (projects.length + 3))) + "vh)";
    // if (project.loc == '')
      // IF EMPTY, RETURN ALL

    return (
      <WorkItem 
        onClick={()=> handleClick(index)}
        id={index} 
        ref={myRefs[index]}
        selected={(index == projectValue) ? true : false } 
        outlined={((index == projectValue) && (filters.length < 1 || (filters.includes(project.loc)))) ? true : false } 
        // filtered={(filters.length < 1 || (filters.includes(project.loc))) ? true : false }
        // filtered={((filters.length < 1 || (filters.includes(project.loc))) && (index == projectValue)) ? true : false }
        filtered={true}
        >
              {project.name}
              {/* <Indicator 
                 outlined={((index == projectValue) && (filters.length < 1 || (filters.includes(project.loc)))) ? true : false } 
                 filtered={(filters.length < 1 || (filters.includes(project.loc))) ? true : false }
              /> */}
        </WorkItem>
    );

  });
  

  //all images
  let images_all = myProjects[projectValue].imgs.map((image, index) => {
    
    // console.log("images printed: " + (index + 1) + " " + image);
    // console.log("size of list" + myProjects[projectValue].imgs.length);
    // var caption = image.substring(3, image.length);

    // let imageFull = myProjects[index].imgPath + image;
    // console.log("image path full: "+ imageFull);
    return (
      <WorkImage>
            <img src={image}/>
      </WorkImage>
    );
    // }
  });

  //MAIN PROJECTS LIST
  let descriptions = myProjects[projectValue].desc.map((desc, index) => {
       return (
       <Desc><br />{desc}</Desc>
      );
  });


  // console.log(window.screen.height);

  return (
    <Container>
      {/* <FiltersContainer>
        <ClearFilters 
          onClick={clearFilters} 
          active={(filters.length > 0) ? true : false }
        >clear</ClearFilters>
        <Filter onClick={projectFilter} active={(filters.includes("project")) ? true : false }>projects <a>{(filters.includes("project")) ? " ✕" : ""}</a></Filter>
        <Filter onClick={studyFilter} active={(filters.includes("study")) ? true : false }>case studies <a>{(filters.includes("study")) ? " ✕" : ""}</a></Filter>
        <Filter onClick={photoFilter} active={(filters.includes("photo")) ? true : false }>photo <a>{(filters.includes("photo")) ? " ✕" : ""}</a></Filter>
        <Filter onClick={audioFilter} active={(filters.includes("audio")) ? true : false }>audio <a>{(filters.includes("audio")) ? " ✕" : ""}</a></Filter>
        <Filter onClick={fabricFilter} active={(filters.includes("event")) ? true : false }>events <a>{(filters.includes("event")) ? " ✕" : ""}</a></Filter>
      </FiltersContainer> */}
      {/* <NavDOMLinkAbout thispage={true} onClick={() => toggle('info')}>ABOUT/CONTACT</NavDOMLinkAbout> */}
      {/* <FiltersToggle onClick={mobileToggle}>filters</FiltersToggle> */}
      {/* <MarkerL /> */}

      <WorkListContainer id="topWorks" ref={ListContainerRef}>
        {projects_list}
        <WorkPreview>
            <WorkDate>{myProjects[projectValue].loc}</WorkDate>
            <WorkDate>{myProjects[projectValue].semester}<br /></WorkDate>
            {descriptions}
            <br />
            <Link><a href={(myProjects[projectValue].link ? myProjects[projectValue].link : '' )} target={"blank"}>{myProjects[projectValue].link.slice(8)}</a></Link>
        </WorkPreview>
      </WorkListContainer>
      
      <WorkImageContainer
        key={projectValue}
        initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}>
        {images_all}
      </WorkImageContainer>
      {/* <MobileLink
        filtered={(filters.length < 1 || (filters.includes(myProjects[projectValue].loc))) ? true : false }
      ><a href={(myProjects[projectValue].link ? myProjects[projectValue].link : '' )} target={"blank"}>{myProjects[projectValue].link}</a></MobileLink>    */}
    </Container>
  );
};

export default withRouter(connect(({ projects }) => ({ projects }))(Works));
